module.exports = __webpack_public_path__ + "static/img/limit_08.0d78d0c6.svg";